import { useCallback, useEffect, useRef, useState } from 'react'
import { io } from 'socket.io-client'

// Same-origin (reverse proxy) или явный URL бэкенда при dev / раздельных портах
const SOCKET_URL =
  process.env.REACT_APP_WS_URL || (typeof window !== 'undefined' ? window.location.origin : '');

export const useSpeedtestSocket = () => {
  const [isConnected, setIsConnected] = useState(false);
  const [testStatus, setTestStatus] = useState(null);
  const [currentTestId, setCurrentTestId] = useState(null);
  const socketRef = useRef(null);

  useEffect(() => {
    socketRef.current = io(SOCKET_URL, {
      path: '/socket.io',
      transports: ['polling', 'websocket'],  // Сначала polling, потом upgrade на WebSocket
      withCredentials: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5,
      autoConnect: true,
      forceNew: true,
    });

    const socket = socketRef.current;

    // Обработчики событий подключения
    socket.on('connect', () => {
      
      setIsConnected(true);
    });

    socket.on('disconnect', (reason) => {
      
      setIsConnected(false);
    });

    socket.on('connect_error', (error) => {
      
      setIsConnected(false);
    });

    // Обработчики событий speedtest
    socket.on('speedtest:created', (data) => {
      
      setCurrentTestId(data.testId);
    });

    socket.on('speedtest:update', (data) => {
      
      setTestStatus(data);
    });

    socket.on('speedtest:error', (data) => {
      
      setTestStatus({
        status: 'error',
        message: data.message,
        progress: 0,
      });
    });

    // Cleanup при размонтировании
    return () => {
      if (socket) {
        
        socket.disconnect();
      }
    };
  }, []);

  // Запустить speedtest
  const startTest = useCallback((ip) => {
    if (socketRef.current && isConnected) {
      
      setTestStatus({ 
        status: 'initializing', 
        progress: 0,
        message: 'Инициализация...'
      });
      setCurrentTestId(null);
      socketRef.current.emit('speedtest:start', { ip });
    } else {
      
      setTestStatus({
        status: 'error',
        message: 'WebSocket не подключен',
        progress: 0,
      });
    }
  }, [isConnected]);

  // Отменить speedtest
  const cancelTest = useCallback(() => {
    if (socketRef.current && currentTestId) {
      
      socketRef.current.emit('speedtest:cancel', { testId: currentTestId });
    }
  }, [currentTestId]);

  // Сбросить статус
  const resetTest = useCallback(() => {
    setTestStatus(null);
    setCurrentTestId(null);
  }, []);

  return {
    isConnected,
    testStatus,
    currentTestId,
    startTest,
    cancelTest,
    resetTest,
  };
};

